import React from 'react';

export default function Header( { children, title, subtitle, icon, className = ''} 
: 
{ children?: React.ReactNode; title?: string, subtitle?: string, className?:string, icon?:any } ){
  const Icon = icon;
  return (
    <div className={"flex flex-wrap lg:flex-nowrap items-center bg-white p-6 border border-slate-300 rounded mb-2 shadow-blue "+className}>
      <div className="flex items-center grow order-0">
        <Icon className={`${subtitle ? "h-10 w-10" : "h-8 w-8"} bg-brand-pale mr-2 text-brand-electric rounded p-[0.375rem]`} />
        <div>
          <h1 className="text-left font-bold text-brand-dark text-2xl md:text-2xl">{title}</h1>
          {subtitle && <span className="block text-sm -mt-1.5">{subtitle}</span>}
        </div>
      </div>
      {children}
    </div>
  )
}
